import { render, staticRenderFns } from "./showCustomers.vue?vue&type=template&id=99c2dcba"
import script from "./showCustomers.vue?vue&type=script&lang=js"
export * from "./showCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports